var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details" },
    [
      _c(
        "v-card",
        { ref: "details" },
        [
          _c(
            "v-toolbar",
            {
              staticStyle: { "border-radius": "0px" },
              attrs: { fixed: "", flat: "", color: "white" }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { color: "black" } }, [
                    _vm._v("mdi-arrow-left")
                  ])
                ],
                1
              ),
              _c(
                "v-toolbar-title",
                {
                  staticStyle: {
                    "text-transform": "capitalize",
                    "font-weight": "bold"
                  }
                },
                [_vm._v(_vm._s(_vm.data.name))]
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            {
              staticClass: "plans-content",
              staticStyle: {
                height: "auto",
                "max-height": "auto",
                padding: "10px",
                margin: "0px auto"
              }
            },
            [
              _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                _c("h4", { staticStyle: { color: "#000" } }, [
                  _vm._v("Key Features & highlights")
                ]),
                _c(
                  "ul",
                  { staticClass: "plan-card-features" },
                  _vm._l(_vm.data.fullFeatures, function(feature, index) {
                    return _c(
                      "li",
                      {
                        key: _vm.data.id + "feature" + index,
                        staticClass: "plan-card-feature",
                        staticStyle: { "font-size": "12px" }
                      },
                      [_vm._v(_vm._s(feature))]
                    )
                  }),
                  0
                )
              ]),
              _c(
                "div",
                { staticStyle: { "margin-bottom": "25px" } },
                [
                  _c("h4", { staticStyle: { color: "#000" } }, [
                    _vm._v("Product description and technical details")
                  ]),
                  Array.isArray(_vm.data.specs) && _vm.data.specs.length >= 1
                    ? _c("v-simple-table", {
                        attrs: { dense: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function() {
                                return [
                                  _c("thead", [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "text-left",
                                          staticStyle: {
                                            "font-size": "10px",
                                            "padding-left": "5px",
                                            "padding-right": "0px"
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticStyle: {
                                              display: "block",
                                              width: "165px"
                                            }
                                          })
                                        ]
                                      ),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "text-left",
                                          staticStyle: {
                                            "font-size": "12px",
                                            "padding-left": "5px",
                                            "padding-right": "0px"
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticStyle: {
                                              display: "block",
                                              width: "165px"
                                            }
                                          })
                                        ]
                                      )
                                    ])
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.data.specs, function(
                                      item,
                                      $index
                                    ) {
                                      return _c(
                                        "tr",
                                        { key: "detailsRow" + $index },
                                        [
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                                "padding-left": "5px",
                                                "padding-right": "0px"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.specification))]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                                "padding-left": "5px",
                                                "padding-right": "0px",
                                                "font-weight": "600"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.detail))]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          746091333
                        )
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm.data.comparison
                ? _c(
                    "div",
                    [
                      _c("h4", { staticStyle: { color: "#000" } }, [
                        _vm._v("Product description and technical details")
                      ]),
                      Array.isArray(_vm.data.comparison) &&
                      _vm.data.comparison.length >= 1
                        ? _c("v-simple-table", {
                            attrs: { dense: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function() {
                                    return [
                                      _c("thead", [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticClass: "text-left",
                                              staticStyle: {
                                                "font-size": "14px",
                                                "padding-left": "5px",
                                                "padding-right": "0px"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "block",
                                                    width: "165px"
                                                  }
                                                },
                                                [_vm._v("Feature")]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "text-left",
                                              staticStyle: {
                                                "font-size": "14px",
                                                "padding-left": "5px",
                                                "padding-right": "0px",
                                                "text-align": "center"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "block",
                                                    width: "60px"
                                                  }
                                                },
                                                [_vm._v("Basic")]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "th",
                                            {
                                              staticClass: "text-left",
                                              staticStyle: {
                                                "font-size": "14px",
                                                "padding-left": "5px",
                                                "padding-right": "0px",
                                                "text-align": "center"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "block",
                                                    width: "60px"
                                                  }
                                                },
                                                [_vm._v("Pro")]
                                              )
                                            ]
                                          )
                                        ])
                                      ]),
                                      _c(
                                        "tbody",
                                        _vm._l(_vm.data.comparison, function(
                                          item,
                                          $index
                                        ) {
                                          return _c(
                                            "tr",
                                            { key: "detailsRow" + $index },
                                            [
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "font-size": "12px",
                                                    "padding-left": "5px",
                                                    "padding-right": "0px",
                                                    "border-right":
                                                      "1px solid #eee",
                                                    "text-align": "left"
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.feature))]
                                              ),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "font-size": "12px",
                                                    "padding-left": "5px",
                                                    "padding-right": "0px",
                                                    "font-weight": "600",
                                                    "border-right":
                                                      "1px solid #eee",
                                                    "text-align": "center"
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.basic))]
                                              ),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "font-size": "12px",
                                                    "padding-left": "5px",
                                                    "padding-right": "0px",
                                                    "font-weight": "600",
                                                    "text-align": "center"
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.pro))]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              2500329468
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }